import React, { useState } from "react";
import useRequest from "../../../../utils/useRequest";
import {
    getIpAbnormalStudentList,
    IpAbnormalItem
} from "../../../../service/exam";
import InvigilationProvider from "../context";
import Layout from "../components/Layout";
import StuTable from "../components/StuTable";
import { AsideIp } from "./components/AsideIp";
import { ColumnProps } from "antd/lib/table/interface";
import { Button } from "antd";
import useModalHandler from "../../../../utils/v3/useModalHandler";
import { IpChangeModal } from "./components/IpChangeModal";

export function ChangeIp() {
    const [examId, setExamId] = useState("");
    const [studentName, setStudentName] = useState("");

    const ipModal = useModalHandler({ component: IpChangeModal });

    const [data, { loading }, refresh] = useRequest(
        () => getIpAbnormalStudentList(examId, studentName),
        {},
        [examId, studentName]
    );

    const columns: ColumnProps<IpAbnormalItem>[] = [
        {
            title: "IP异常次数",
            dataIndex: "ipAbnormalNum",
            render: (num, item) => (
                <Button
                    type="link"
                    onClick={() =>
                        ipModal.open({
                            examId: item.examId,
                            studentNo: item.studentNo
                        })
                    }>
                    {num}
                </Button>
            )
        }
    ];

    return (
        <InvigilationProvider
            examId={examId}
            setExamId={setExamId}
            examList={data?.conditionQueryList || []}
            dataSource={data?.dataList || []}>
            <Layout
                refresh={refresh}
                title="IP异常监测"
                table={
                    <StuTable
                        onErrChange={refresh}
                        dataSource={data?.dataList || []}
                        loading={loading}
                        columns={columns}
                        buttonShow={[true, false, true, false]}
                    />
                }
                aside={<AsideIp examId={examId} />}
                onSearch={setStudentName}
            />

            {ipModal.render()}
        </InvigilationProvider>
    );
}
